import { Optional } from 'chaika-frontend-types/frontend-cms';

import { DateFormat, DateHelper } from '@utils/DateHelper';
import { formatAgeString } from '@utils/formatAgeString';

export function formatBirthDateWithAge(birthDate: Optional<string | Date>): string {
    if (!birthDate) {
        return '- ';
    }
    const date = birthDate instanceof Date ? birthDate : new Date(birthDate);
    return `${DateHelper.format(date, DateFormat.DateWithDotSeparator)} ${formatAgeString(date)}`;
}
